import AccountCircle from '@mui/icons-material/AccountCircle';
import { IconButton, Typography } from '@mui/material';
import type React from 'react';
import { useTranslation } from 'react-i18next';

interface ProfileIconComponentProps {
  profileMenuId: string;
  onProfileMenuOpen: (event: React.MouseEvent<HTMLElement>) => void;
  className?: string;
  showUserName?: boolean;
  userName?: string;
}

const ProfileIconComponent: React.FC<ProfileIconComponentProps> = ({
  profileMenuId,
  onProfileMenuOpen,
  className,
  showUserName = false,
  userName,
}) => {
  const { t } = useTranslation();

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    onProfileMenuOpen(event);
  };

  return (
    <IconButton
      edge={showUserName ? 'end' : undefined}
      aria-label={t('profile.accountAria', 'account of current user')}
      aria-controls={profileMenuId}
      aria-haspopup="true"
      onClick={handleClick}
      color="inherit"
    >
        <AccountCircle className={className} />
      {showUserName && userName && (
        <div style={{ fontSize: '15px', marginLeft: '10px' }}>{userName}</div>
      )}
      {!showUserName && (
        <Typography
          sx={{
            display: {
              xs: 'block',
              md: 'none',
            },
          }}
        >
          {t('profile.title', 'Profile')}
        </Typography>
      )}
    </IconButton>
  );
};

export default ProfileIconComponent;

